module.exports = __webpack_public_path__ + "img/renshu.12487d50.png";